import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Typography } from 'rmwc/Typography';
import { LoadingBar } from '../../components/util/LoadingBar';
import { List, ListItem, ListItemText } from 'rmwc/List';
import { Card, CardPrimary, CardTitle, CardSupportingText, CardActions, CardAction } from 'rmwc/Card';
import { Text } from '../../components/Text';
import { checkForSimulations, runFullSimulation } from '../../actions/simulationActions';
import { withLoading } from '../../components/util/LoadingWrapper';
import { animateSimulationOnboarding, preventFromGoingBack } from '../../actions/userActions';
import { trackEvent } from '../../actions/trackEventActions';

const STEPS = [
  {
    text: 'Finding Basic Strategies',
    imgPath: 'autosave_1',
  },
  {
    text: 'Assessing situation fit',
    imgPath: 'icon_investments',
  },
  {
    text: 'Estimating Cash Flows',
    imgPath: 'income_estimate',
  },
  {
    text: 'Computing Financial Scores',
    imgPath: 'grading',
  },
];
const DELAY = 1000;

class ThankYou extends Component {
  state = { step: 0 };

  componentDidMount = () => {
    const { dispatch, qna_hash } = this.props;
    if (qna_hash.monthlySavings) {
      setTimeout(this.advanceStep, DELAY);
      dispatch(animateSimulationOnboarding(true));
      dispatch(runFullSimulation());
      dispatch(preventFromGoingBack());
      dispatch(checkForSimulations(30));
    }
  };

  componentDidUpdate(prevProps) {
    const { dispatch, qna_hash } = this.props;
    if (qna_hash.monthlySavings && !prevProps.qna_hash.monthlySavings) {
      setTimeout(this.advanceStep, DELAY);
      dispatch(animateSimulationOnboarding(true));
      dispatch(runFullSimulation());
      dispatch(preventFromGoingBack());
      dispatch(checkForSimulations(30));
    }
  }

  advanceStep = () => {
    const { dispatch } = this.props;
    this.setState({ step: this.state.step + 1 }, () => {
      if (this.state.step < STEPS.length) {
        setTimeout(this.advanceStep, DELAY);
      } else {
        dispatch(animateSimulationOnboarding(false));
      }
    });
  };

  _onContinue = () => {
    this.props.onContinue();
    this.props.dispatch(trackEvent('CONTINUED_FROM_THANK_YOU_PAGE'));
  };

  render() {
    const stepComponent = (step, stepIndex) => (
      <ListItem key={`step-${stepIndex}`} className="animated fadeInUp">
        <img src={require(`../../images/${step.imgPath}`)} height={35} width={35} style={{ marginRight: '10px' }} />
        <ListItemText>{step.text}</ListItemText>
      </ListItem>
    );

    const { wrapper, qna_hash } = this.props;

    if (!qna_hash.monthlySavings) {
      return <LoadingBar />;
    }

    const CardActionWithLoading = withLoading(CardAction);

    const isLoading =
      !this.props.simulations.results ||
      this.props.simulations.isRunning ||
      this.props.user.uiState.isSimulationAnimating;

    return (
      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="headline6">Calculating Your Financial Health Scores Now</Text>
        </div>

        <div
          style={{ height: '280px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
          className="pb-3"
        >
          <List style={{ height: '208px', width: '100%' }} nonInteractive={true}>
            {STEPS.filter((step, i) => i < this.state.step).map(stepComponent)}
          </List>
          <Text use="subtitle1" style={{ marginLeft: '10px', marginTop: '10px', marginBottom: '0' }}>
            {isLoading ? ' ' : 'Your results are ready!'}
          </Text>
        </div>

        <CardActions className="p-3" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <CardActionWithLoading
            load={{
              isLoading,
              customWaitMessage: 'Calculating',
            }}
            unelevated
            onClick={this._onContinue}
            theme={isLoading ? null : 'secondary-bg on-secondary'}
          >
            Click to view
          </CardActionWithLoading>
        </CardActions>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    qna_hash: state.onboarding.qna_hash,
    simulations: state.simulations,
    user: state.user,
  };
}

export default connect(mapStateToProps)(withRouter(ThankYou));
